/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createOrUpdateMerchantWorkweekConfiguration} from '../api'

export const useMutationCreateOrUpdateMerchantWorkweekConfiguration = createReactQueryMutationHook('createOrUpdateMerchantWorkweekConfiguration', createOrUpdateMerchantWorkweekConfiguration)
